module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "fut_toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "fut_toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Begin Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note About the Author and Translator")])]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc-sp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', {
    staticClass: "fut_tit"
  }, [_c('a', {
    attrs: {
      "href": "http://us.macmillan.com/static/ebooks/WIP/index.html?utm_source=ebook&utm_medium=backad&utm_term=na-wipsignup&utm_content=fullpg-signup-nl&utm_campaign=wipsignup&et=27109-n15162182",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "image",
      "src": "images/WIP-NewsletterSignup.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84b0e23a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/mini_toc.vue
// module id = 60
// module chunks = 0